/**
 * 其他业务
 */
import React from 'react';
import { Input, Row, Col, Button, Select, Tooltip, Icon, DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
import TradeDeductionEdit from './TradeDeductionEdit';
import http from '../../../axios/http';
import NewPlateNoEdit from './NewPlateNoEdit';
import CollectionTimeEdit from './CollectionTimeEdit';
import TradeDeductionDetail from './TradeDeductionDetail';
import TradeDeductionCancel from './TradeDeductionCancel'
// 加载权限编码
import { global_data } from '../../ui/auth'



class TradeDeductionIndex extends React.Component {
    deductionTypeMap = { 14: '新车上牌', 15: '其他业务' };
    customerSourceMap = { 1: '市场会员', 2: '直接客户', 3: '其他' };
    deductionTypeArray = [{
        code: 14,
        text: "新车上牌",
    }, {
        code: 15,
        text: "其他业务",
    }];
    customerSourceArray = [{
        code: 1,
        text: "市场会员",
    }, {
        code: 2,
        text: "直接客户",
    }, {
        code: 3,
        text: "其他",
    }];

    columns = [{
        title: '客户来源',
        dataIndex: 'customerSource',
        width: '10%',
        format: this.customerSourceMap
    }, {
        title: '客户名称',
        dataIndex: 'customerName',
        width: '15%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '扣款类型',
        dataIndex: 'type',
        width: '10%',
        format: this.deductionTypeMap
    }, {
        title: '金额',
        dataIndex: 'actualComission',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '接单人员',
        dataIndex: 'grabUser',
        width: '10%',
    }, {
        title: '到账时间',
        dataIndex: 'collectionTime',
        width: '10%',
    }, {
        title: '新车牌号',
        dataIndex: 'newPlateNo',
        width: '10%',
    }, {
        title: '状态',
        dataIndex: 'statusStr',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {
                    global_data.authCode.includes("TRADE_DEDUCTION_UPDATE")?
                        <Tooltip title="编辑">
                            <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.edit.bind(this, record)} />
                        </Tooltip>
                        : ""
                }
                {global_data.authCode.includes("TRADE_DEDUCTION_NEW")?
                <Tooltip title="录入新车牌">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.inputNewPlateNo.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TRADE_DEDUCTION_PAYTIME")?
                <Tooltip title="录入到款时间">
                    <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.inputCollectionTime.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.record.bind(this, record)} />
                </Tooltip>
                {
                    this.state.authButton["TRADE_DEDUCTION_CANCEL"] && record.status !== "cancel" ?
                        <Tooltip title="撤单">
                            <Icon type="close-circle" theme="filled" className="table-operate-icon" onClick={this.cancel.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ""
                }
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据

        loadData: '',
        queryData: {}, //查询数据

        orgList: [], //市场信息

        discount: 1,

        applicationId: "",
        newPlateNoVisible: false,
        newPlateNo: "",
        collectionTimeVisible: false,
        collectionTime: null,
        recordData: {},
        recordVisible: false,

        cancelVisible: false, //撤单

        authButton: {}, //有权限的按钮
    };

    componentDidMount() {
        this.getAgentDiscount();

        //过户代办业务的编辑和撤单功能权限
        let authCodes = ["TRADE_DEDUCTION_EDIT", "TRADE_DEDUCTION_CANCEL"];
        let authButton = {};
        for (let i = 0; i < global_data.authCode.length; i++) {
            for (let j = 0; j < authCodes.length; j++) {
                if (global_data.authCode[i] === authCodes[j]) {
                    authButton[authCodes[j]] = true;
                }
            }
        }
        this.setState({ authButton: authButton });
    }

    getAgentDiscount = () => {
        http.get({
            url: '/tradeDeduction/getDiscount',
            success: (res) => {
                this.setState({ discount: res ? res : 1 });
            }
        });
    }

    add = () => {
        this.setState({ visible: true, editData: { customerSource: 1, hasDiscount: 0 } });
    }

    edit = (info, e) => {
        http.get({
            url: '/tradeDeduction/getTradeDeduction',
            data: { applicationId: info.applicationId },
            success: (res) => {
                this.setState({ editData: res, visible: true });
            }
        });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }

    //录入新的车牌信息
    inputNewPlateNo = (info, e) => {
        this.setState({ "newPlateNoVisible": true, "applicationId": info.applicationId, "newPlateNo": info.newPlateNo });
    }

    //录入到款时间
    inputCollectionTime = (info, e) => {
        this.setState({ "collectionTimeVisible": true, "applicationId": info.applicationId, "collectionTime": info.collectionTime });
    }

    //单据的历史记录状态
    record = (info, e) => {
        http.get({
            url: '/tradeDeduction/getTradeDeduction',
            data: { applicationId: info.applicationId },
            success: (res) => {
                this.setState({ recordData: res, recordVisible: true });
            }
        });
    }

    //将申请单退回到待接单状态
    cancel = (info, e) => {
        this.setState({ cancelVisible: true, applicationId: info });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData)
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车架号"
                                    onSearch={this.inputSearch.bind(this, "vin")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch.bind(this, "customerName")}
                                    enterButton
                                    style={{ width: '200px', margin: '0 10px' }}
                                />
                                <Select onChange={this.selectChange.bind(this, "type")} allowClear={true} style={{ width: 180 }}>
                                    {this.deductionTypeArray.map(d => <Select.Option key={d["code"]}>{d["text"]}</Select.Option>)}
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("TRADE_DEDUCTION_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/tradeDeduction/pageTradeDeduction"
                    columns={this.columns}
                    loadData={(func) => this.loadData = func}
                />
                <TradeDeductionEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    dictArray={{ "customerSource": this.customerSourceArray, "type": this.deductionTypeArray }}
                    onRef={(ref) => { this.setState({ ref: ref }) }}
                    discount={this.state.discount}
                />
                <NewPlateNoEdit
                    visible={this.state.newPlateNoVisible}
                    onCancel={() => { this.setState({ newPlateNoVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    plateNo={this.state.newPlateNo}
                />
                <CollectionTimeEdit
                    visible={this.state.collectionTimeVisible}
                    onCancel={() => { this.setState({ collectionTimeVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    collectionTime={this.state.collectionTime}
                />
                <TradeDeductionDetail
                    visible={this.state.recordVisible}
                    editData={this.state.recordData}
                    onCancel={() => { this.setState({ recordVisible: false }) }}
                />
                <TradeDeductionCancel
                    visible={this.state.cancelVisible}
                    onCancel={() => { this.setState({ cancelVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }

}

export default TradeDeductionIndex;